import PropTypes from "prop-types";
import { useEffect, useState } from "react";
// import { GetrelatedProducts } from '../data/productController';
import { adminUrl } from "../../public/src/urls";
import useShopNow from "../components/ShopNow";
import { CurrencyConverter } from "../components/Currency";
import { QuickViewModal } from "../components/QuickViewModal";
import { ContactOnWP } from "../components/whatsapp";
import { useNavigate } from "react-router-dom";
import { fetchGetByID, fetchGet } from "../fetchData/fetchGet";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import {
  handelAddWishList,
  handelRemoveWishList,
} from "../components/useWishlist";
import useWindowSize from "../components/useWindowSize";
export const Related = ({ Product, ShopInfo, isLogedIn }) => {
  const { isMobile } = useWindowSize();
  const shopNow = useShopNow();

  const [Wishlist, setWishlist] = useState([]);

  const navigate = useNavigate();

  // const handelAddWishList = (product) => {
  // 	if (isLogedIn.isLogedIn) {
  // 		const updatedWishlist = [...(Wishlist || []), product];
  // 		setWishlist(updatedWishlist);
  // 		fetchAdd('TB_WishList', 'TB_WishList', 'WishListID', product, [], '');
  // 	} else {
  // 		navigate('/Login');
  // 	}
  // };
  // const handelRemoveWishList = (product) => {
  // 	if (isLogedIn.isLogedIn) {
  // 		// DeleteWishlist(product);
  // 		fetchDelete('TB_WishList', 'WishListID', product);
  // 		const updatedWishlist = Wishlist.filter((item) => item.ProductID !== product.ProductID);
  // 		setWishlist(updatedWishlist);
  // 	} else {
  // 		navigate('/Login');
  // 	}
  // };

  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        // const Gwishlist = await GetWishlist();
        const Gwishlist = await fetchGet("TB_WishList");
        setWishlist(Gwishlist);
      } catch (error) {
        console.error(error);
      }
    };
    fetchWishlist();
  }, []);

  const [Relateds, settRelated] = useState([]);

  useEffect(() => {
    const fetchedProductInfos = async () => {
      try {
        const RelatedProducts = await fetchGetByID(
          "Vw_Products",
          "SCategoryID",
          Product.SCategoryID
        );
        settRelated(RelatedProducts);
      } catch (err) {
        console.error("Failed to fetch products" + err);
      }
    };
    fetchedProductInfos();
  }, [Product]);

  const [selectedProduct, setSelectedProduct] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openQuickView = async (product) => {
    await setSelectedProduct(product);
    setIsModalOpen(true);
  };

  return (
    <>
      <section className="section-b-space ratio_asos">
        <div className="container">
          <div className="row">
            <div className="col-12 product-related">
              <h2>related products</h2>
            </div>
          </div>
          <div className="row search-product">
            {Relateds &&
              Relateds.map((Related, i) => (
                <div
                  key={i}
                  className="col-xl-2 col-md-4 col-6 m-0 rounded p-2"
                  // onClick={() => shopNow(Related)}
                >
                  <div className="product-box">
                    <div className="img-wrapper">
                      <div className="front">
                        <LazyLoadImage
                          src={Related.Photo ? adminUrl + Related.Photo : ""}
                          effect="blur"
                          style={{
                            width: isMobile ? "150px" : "250px",
                            height: isMobile ? "150px" : "150px",
                            border: "1px solid #efe8e8",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                      <div className="back">
                        <LazyLoadImage
                          src={Related.Photo ? adminUrl + Related.Photo : ""}
                          effect="blur"
                          onClick={() => shopNow(Related)}
                          style={{
                            width: isMobile ? "150px" : "250px",
                            height: isMobile ? "150px" : "150px",
                            border: "1px solid #efe8e8",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                      <div className="cart-info cart-wrap">
                        {/* <button
                        data-bs-toggle="modal"
                        data-bs-target="#addtocart"
                        title="Add to cart"
                      >
                        <i className="ti-shopping-cart"></i>
                      </button>{" "} */}
                        <i
                          className="fa fa-whatsapp"
                          onClick={() =>
                            ContactOnWP({ ShopInfo, Product: Related })
                          }
                        ></i>
                        <a
                          title="Add to Wishlist"
                          onClick={() =>
                            Wishlist &&
                            Wishlist.some(
                              (wish) => wish.ProductID === Related.ProductID
                            )
                              ? handelRemoveWishList(
                                  Product,
                                  isLogedIn,
                                  Wishlist,
                                  setWishlist,
                                  navigate
                                )
                              : handelAddWishList(
                                  Product,
                                  isLogedIn,
                                  Wishlist,
                                  setWishlist,
                                  navigate
                                )
                          }
                        >
                          <i
                            className={
                              Wishlist &&
                              Wishlist.some(
                                (wish) => wish.ProductID === Related.ProductID
                              )
                                ? "fa fa-heart"
                                : "ti-heart"
                            }
                            aria-hidden="true"
                            style={{
                              color:
                                Wishlist &&
                                Wishlist.some(
                                  (wish) => wish.ProductID === Related.ProductID
                                )
                                  ? "red"
                                  : "initial",
                            }}
                          ></i>
                        </a>{" "}
                        <a
                          data-bs-toggle="modal"
                          data-bs-target="#quick-view"
                          title="Quick View"
                          onClick={() => openQuickView(Related)}
                        >
                          <i className="ti-search" aria-hidden="true"></i>
                        </a>{" "}
                        <a title="Compare">
                          <i className="ti-reload" aria-hidden="true"></i>
                        </a>
                      </div>
                    </div>
                    <div className="product-detail">
                      <div className="rating">
                        <i className="fa fa-star"></i>{" "}
                        <i className="fa fa-star"></i>{" "}
                        <i className="fa fa-star"></i>{" "}
                        <i className="fa fa-star"></i>{" "}
                        <i className="fa fa-star"></i>
                      </div>
                      <a href="product-page(no-sidebar).html">
                        <h6>{Related.ProductName}</h6>
                      </a>
                      <h4>
                        {Related.HasDiscount
                          ? CurrencyConverter(Related.DiscountPrice)
                          : CurrencyConverter(Related.Price)}
                      </h4>
                      <del>
                        {Related.HasDiscount
                          ? CurrencyConverter(Related.Price)
                          : ""}
                      </del>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>
      {isModalOpen && (
        <QuickViewModal
          product={selectedProduct}
          onClose={() => setIsModalOpen(false) + setSelectedProduct()}
        />
      )}
    </>
  );
};

Related.propTypes = {
  Product: PropTypes.object.isRequired,
  isLogedIn: PropTypes.object.isRequired,
};
Related.defaultProps = {
  Product: {},
};
